import { Module } from '@nestjs/common';
import { AiConfigModule } from '../ai-dashboard/ai-config/ai-config.module';
import { AiUsageModule } from '../ai-usage/ai-usage.module';
import { AiProviderService } from '../ai-dashboard/ai-provider/ai-provider.service';
import { ConciliacionBancariaIaController } from './conciliacion-bancaria-ia.controller';
import { ConciliacionBancariaIaService } from './conciliacion-bancaria-ia.service';
import { ArchivoMovimientosParserService } from './lib/archivo-movimientos.parser';

/**
 * Conciliación Bancaria con IA — módulo independiente (standalone).
 * PrismaModule es @Global. AiConfigModule + AiUsageModule alimentan
 * AiProviderService (interpretación IA de PDF/TXT libres + medición de tokens).
 */
@Module({
  imports: [AiConfigModule, AiUsageModule],
  controllers: [ConciliacionBancariaIaController],
  providers: [ConciliacionBancariaIaService, ArchivoMovimientosParserService, AiProviderService],
})
export class ConciliacionBancariaIaModule {}
